import {ValueObject} from '@s-ui/domain'

export class PhoneVerificationStatusUserValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {bool} data.isVerified
   * */
}
